export type AnimeCategory = "new" | "classic" | "guoman" | "movie";

export interface AnimeItem {
  id: number;
  title: string;
  category: AnimeCategory;
  tags: string[];
  episode: string;
  rating: string;
  year: string;
  description: string;
  image: string;
  lines: string[];
}

export const animeCategories: { key: AnimeCategory | "all"; label: string }[] = [
  { key: "all", label: "全部番剧" },
  { key: "new", label: "热门新番" },
  { key: "classic", label: "经典老番" },
  { key: "guoman", label: "国漫精选" },
  { key: "movie", label: "剧场版" },
];

export const animeList: AnimeItem[] = [
  {
    id: 1,
    title: "星际漫游者",
    category: "new",
    tags: ["科幻", "冒险"],
    episode: "更新至第18话",
    rating: "9.4",
    year: "2026",
    description: "少年舰队穿越星海,多线路高清追更不卡顿。",
    image: "https://readdy.ai/api/search-image?query=A%20bold%20anime%20key%20visual%20poster%20of%20a%20young%20space%20pilot%20with%20a%20glowing%20emerald%20energy%20sword%20standing%20on%20a%20futuristic%20floating%20island%2C%20warm%20coral%20orange%20and%20teal%20color%20palette%2C%20dynamic%20cinematic%20composition%2C%20clean%20simple%20background%2C%20vibrant%20high%20quality%20anime%20illustration%2C%20portrait%20orientation&width=600&height=800&seq=anime-01-new&orientation=portrait",
    lines: ["主线路 · 超清", "备用线路 · 高清", "备用线路 · 流畅"],
  },
  {
    id: 2,
    title: "幻境物语",
    category: "new",
    tags: ["奇幻", "治愈"],
    episode: "更新至第12话",
    rating: "9.1",
    year: "2026",
    description: "梦境与现实交织的治愈冒险,自动选源一路顺畅。",
    image: "https://readdy.ai/api/search-image?query=A%20soft%20anime%20key%20visual%20poster%20of%20a%20gentle%20girl%20surrounded%20by%20floating%20glowing%20lanterns%20in%20a%20dreamy%20forest%2C%20warm%20coral%20and%20golden%20amber%20color%20palette%2C%20soothing%20fantasy%20atmosphere%2C%20clean%20simple%20background%2C%20high%20quality%20anime%20illustration%2C%20portrait%20orientation&width=600&height=800&seq=anime-02-new&orientation=portrait",
    lines: ["主线路 · 超清", "备用线路 · 高清"],
  },
  {
    id: 3,
    title: "剑与旋律",
    category: "new",
    tags: ["战斗", "音乐"],
    episode: "更新至第9话",
    rating: "8.9",
    year: "2026",
    description: "以剑为琴奏响战歌,多线路秒切畅快追更。",
    image: "https://readdy.ai/api/search-image?query=A%20dynamic%20anime%20key%20visual%20poster%20of%20a%20swordsman%20playing%20a%20luminous%20string%20instrument%20that%20becomes%20a%20blade%2C%20energy%20ripples%20in%20air%2C%20warm%20coral%20and%20teal%20accent%20palette%2C%20dynamic%20cinematic%20composition%2C%20clean%20background%2C%20vibrant%20anime%20illustration%2C%20portrait%20orientation&width=600&height=800&seq=anime-03-new&orientation=portrait",
    lines: ["主线路 · 超清", "备用线路 · 高清", "备用线路 · 流畅"],
  },
  {
    id: 4,
    title: "时光档案馆",
    category: "classic",
    tags: ["悬疑", "穿越"],
    episode: "全24话",
    rating: "9.6",
    year: "2021",
    description: "经典悬疑穿越神作,老番也能多源稳定观看。",
    image: "https://readdy.ai/api/search-image?query=A%20mysterious%20anime%20key%20visual%20poster%20of%20a%20young%20man%20standing%20before%20a%20giant%20antique%20clock%20inside%20a%20grand%20vintage%20archive%20library%2C%20warm%20amber%20and%20coral%20palette%2C%20intriguing%20cinematic%20lighting%2C%20clean%20background%2C%20high%20quality%20anime%20illustration%2C%20portrait%20orientation&width=600&height=800&seq=anime-04-classic&orientation=portrait",
    lines: ["主线路 · 超清", "备用线路 · 高清"],
  },
  {
    id: 5,
    title: "山海冒险团",
    category: "classic",
    tags: ["冒险", "热血"],
    episode: "全26话",
    rating: "9.3",
    year: "2019",
    description: "远古神兽与少年少女的热血旅程,一路稳播。",
    image: "https://readdy.ai/api/search-image?query=A%20epic%20anime%20key%20visual%20poster%20of%20a%20group%20of%20adventurers%20riding%20a%20mythical%20beast%20through%20cloudy%20mountain%20peaks%2C%20warm%20coral%20and%20golden%20amber%20palette%2C%20dynamic%20adventure%20composition%2C%20clean%20background%2C%20vibrant%20anime%20illustration%2C%20portrait%20orientation&width=600&height=800&seq=anime-05-classic&orientation=portrait",
    lines: ["主线路 · 高清", "备用线路 · 流畅", "备用线路 · 极速"],
  },
  {
    id: 6,
    title: "苍蓝之刃",
    category: "classic",
    tags: ["战斗", "奇幻"],
    episode: "全22话",
    rating: "9.0",
    year: "2017",
    description: "经典战斗番常看常新,备用线路随时待命。",
    image: "https://readdy.ai/api/search-image?query=A%20powerful%20anime%20key%20visual%20poster%20of%20a%20female%20warrior%20holding%20a%20blue%20crystal%20blade%2C%20standing%20against%20a%20stormy%20sky%2C%20teal%20and%20coral%20accent%20palette%2C%20dramatic%20cinematic%20lighting%2C%20clean%20background%2C%20high%20quality%20anime%20illustration%2C%20portrait%20orientation&width=600&height=800&seq=anime-06-classic&orientation=portrait",
    lines: ["主线路 · 超清", "备用线路 · 高清"],
  },
  {
    id: 7,
    title: "山河少年志",
    category: "guoman",
    tags: ["国漫", "古风"],
    episode: "更新至第30话",
    rating: "9.5",
    year: "2026",
    description: "国风古韵的少年成长记,高清多源稳定追更。",
    image: "https://readdy.ai/api/search-image?query=A%20chinese%20anime%20key%20visual%20poster%20of%20a%20young%20ink-style%20warrior%20with%20a%20calligraphy%20brush%20sword%20on%20a%20misty%20mountain%20river%20landscape%2C%20warm%20coral%20and%20golden%20amber%20palette%2C%20elegant%20eastern%20aesthetic%2C%20clean%20background%2C%20high%20quality%20anime%20illustration%2C%20portrait%20orientation&width=600&height=800&seq=anime-07-guoman&orientation=portrait",
    lines: ["主线路 · 超清", "备用线路 · 高清", "备用线路 · 流畅"],
  },
  {
    id: 8,
    title: "都市异闻录",
    category: "guoman",
    tags: ["都市", "奇幻"],
    episode: "更新至第16话",
    rating: "8.8",
    year: "2026",
    description: "现代都市里的奇妙际遇,自动选源随时在线。",
    image: "https://readdy.ai/api/search-image?query=A%20modern%20chinese%20anime%20key%20visual%20poster%20of%20a%20stylish%20young%20detective%20on%20a%20neon-lit%20city%20street%20at%20dusk%2C%20warm%20coral%20and%20teal%20palette%2C%20trendy%20urban%20mood%2C%20clean%20background%2C%20vibrant%20anime%20illustration%2C%20portrait%20orientation&width=600&height=800&seq=anime-08-guoman&orientation=portrait",
    lines: ["主线路 · 高清", "备用线路 · 流畅"],
  },
  {
    id: 9,
    title: "小猴陪你追番",
    category: "guoman",
    tags: ["搞笑", "日常"],
    episode: "更新至第20话",
    rating: "9.2",
    year: "2026",
    description: "萌趣日常爆笑不断,小猴陪你一路不卡顿。",
    image: "https://readdy.ai/api/search-image?query=A%20cute%20chinese%20anime%20key%20visual%20poster%20of%20an%20adorable%20monkey%20companion%20and%20a%20happy%20student%20watching%20TV%20with%20snacks%2C%20warm%20coral%20and%20golden%20amber%20palette%2C%20playful%20and%20cozy%20mood%2C%20clean%20background%2C%20high%20quality%20anime%20illustration%2C%20portrait%20orientation&width=600&height=800&seq=anime-09-guoman&orientation=portrait",
    lines: ["主线路 · 超清", "备用线路 · 高清", "备用线路 · 流畅"],
  },
  {
    id: 10,
    title: "星海剧场",
    category: "movie",
    tags: ["剧场版", "科幻"],
    episode: "全1话",
    rating: "9.7",
    year: "2025",
    description: "口碑剧场版巨制,大屏高清多线路畅看。",
    image: "https://readdy.ai/api/search-image?query=A%20epic%20anime%20movie%20poster%20of%20a%20spaceship%20fleet%20flying%20toward%20a%20giant%20glowing%20nebula%2C%20warm%20coral%20and%20deep%20teal%20palette%2C%20breathtaking%20cinematic%20scale%2C%20clean%20background%2C%20high%20quality%20anime%20illustration%2C%20portrait%20orientation&width=600&height=800&seq=anime-10-movie&orientation=portrait",
    lines: ["主线路 · 超清", "备用线路 · 高清", "备用线路 · 极速"],
  },
  {
    id: 11,
    title: "夏日回忆录",
    category: "movie",
    tags: ["剧场版", "治愈"],
    episode: "全1话",
    rating: "9.0",
    year: "2024",
    description: "夏天、烟火与少年的约定,温暖治愈一镜到底。",
    image: "https://readdy.ai/api/search-image?query=A%20warm%20anime%20movie%20poster%20of%20two%20friends%20watching%20fireworks%20by%20the%20sea%20on%20a%20summer%20night%2C%20warm%20coral%20and%20golden%20amber%20palette%2C%20nostalgic%20cozy%20mood%2C%20clean%20background%2C%20high%20quality%20anime%20illustration%2C%20portrait%20orientation&width=600&height=800&seq=anime-11-movie&orientation=portrait",
    lines: ["主线路 · 高清", "备用线路 · 流畅"],
  },
  {
    id: 12,
    title: "逆转时空",
    category: "movie",
    tags: ["剧场版", "悬疑"],
    episode: "全1话",
    rating: "9.3",
    year: "2024",
    description: "时间轮回的烧脑剧场版,多线路稳定流畅。",
    image: "https://readdy.ai/api/search-image?query=A%20mind-bending%20anime%20movie%20poster%20of%20a%20shattered%20clock%20tower%20with%20glowing%20fragments%20floating%20around%20a%20silhouetted%20hero%2C%20warm%20coral%20and%20teal%20palette%2C%20mysterious%20cinematic%20lighting%2C%20clean%20background%2C%20high%20quality%20anime%20illustration%2C%20portrait%20orientation&width=600&height=800&seq=anime-12-movie&orientation=portrait",
    lines: ["主线路 · 超清", "备用线路 · 高清"],
  },
];